import React from "react";
import Form from "react-bootstrap/Form";
import FormGroup from "react-bootstrap/FormGroup";
import Button from "react-bootstrap/Button";

const NewCohabitantForm = (props) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const params = {
      first_name: formData.get("first_name"),
      last_name: formData.get("last_name"),
      date_of_birth: formData.get("date_of_birth"),
      relation: formData.get("relation"),
    };
    props.createCohabitant(params);
    event.currentTarget.reset();
    document.querySelectorAll("button.accordion-button")[2].click()
  };
  return (
    <>
      <Form className="form d-flex flex-column" onSubmit={handleSubmit}>
        <FormGroup className="border border-dark rounded m-1 text-center">
          <Form.Label>
            <u>First name</u>
          </Form.Label>
          <Form.Control
            htmlFor="first_name"
            id="first_name"
            name="first_name"
            type="text"
          />
        </FormGroup>
        <FormGroup className="border border-dark rounded m-1 text-center">
          <Form.Label>
            <u>Last name</u>
          </Form.Label>
          <Form.Control
            htmlFor="last_name"
            id="last_name"
            name="last_name"
            type="text"
          />
        </FormGroup>
        <FormGroup className="border border-dark rounded m-1 text-center">
          <Form.Label>
            <u>Date of birth</u>
          </Form.Label>
          <Form.Control
            htmlFor="date_of_birth"
            id="date_of_birth"
            name="date_of_birth"
            type="date"
          />
        </FormGroup>
        <FormGroup className="border border-dark rounded m-1 text-center">
          <Form.Label>
            <u>Relation</u>
          </Form.Label>

          <Form.Control
            htmlFor="relation"
            id="relation"
            name="relation"
            type="text"
          />
        </FormGroup>
        <Button variant="primary" type="submit">
          Submit
        </Button>
      </Form>
    </>
  );
};

export default NewCohabitantForm;
